import request from '@/utils/request'

// C-公司公海列表
export function getCustomerListPage (data) {
  return request({
    url: '/crm/customer/getCustomerListPage',
    method: 'get',
    params: data
  })
}


// C-设置为必跟客户-放入团队公海-加入我的客户
export function setAlwaysFollow (data) {
  return request({
    url: '/crm/customer/setAlwaysFollow',
    method: 'post',
    data: data
  })
}

// C-左侧客户菜单角标数量
export function getAllCustomerMenuBadgeCount (query) {
  return request({
    url: '/crm/customer/getAllCustomerMenuBadgeCount',
    method: 'get',
    params: query
  })
}